import { Component } from '@angular/core';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-iso-cjun-graph',
  templateUrl: './iso-cjun-graph.component.html',
  styleUrls: ['./iso-cjun-graph.component.css']
})
export class IsoCjunGraphComponent {
  data: any;
  options: any;
  loading: boolean = true;

  constructor(private dataService: DataService){}

  ngOnInit() {
    this.dataService.getIsoGraph().then(data => {
      this.data = data[0];
      this.loading = false;
      console.log(data);
    });

    /*this.data = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                label: 'First Dataset',
                data: [65, 59, 80, 81, 56, 55, 40],
                tension: 0.4
            },
            {
                label: 'Second Dataset',
                data: [28, 48, 40, 19, 86, 27, 90],
                tension: 0.4
            }
        ]
    };*/

    this.options = {
        maintainAspectRatio: false,
        aspectRatio: .4,
        showLine: false
    };
  }
}
